import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { saveAs } from 'file-saver-es';
import { HttpClient } from '@angular/common/http';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { Subscription } from 'rxjs';
import * as cities from '../../../../../../assets/eg.json';
import { FormValidatorService } from '../../../../../shared/services/form-validator.service';
import { WithdrawalStatusService } from '../../../../../shared/services/withdrawal-status.service';
import { BehaviorSubjectActivationsService } from '../../../../../shared/services/behavior-subject-activations.service';
import { WithdrawalUploadFileService } from '../../services/withdrawal-upload-file.service';
import { Validators } from '../../../../../shared/validators';
import { CCRequestActionService } from '../../services/ccrequest-action.service';
import { CCFetchBusinessDataService } from '../../services/ccfetch-business-data.service';
import { CCSaveBusinessDataService } from '../../services/ccsave-business-data.service';
import { GetActivationRequestService } from './get-activation-request.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../../../shared/services/language.service';
import Swal from 'sweetalert2';
import { CONSTANT_CUSTOMER_SUPPORT_INFO } from 'src/app/shared/ConstantCustomerSupportInfo';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-credit-card-request-form',
  templateUrl: './credit-card-request-form.component.html',
  styleUrls: ['./credit-card-request-form.component.scss']
})
export class CreditCardRequestFormComponent implements OnInit, AfterViewInit {
  fvPage1 = new FormValidatorService();
  fvPage2 = new FormValidatorService();
  fvPage3 = new FormValidatorService();
  imageSrc: any
  page1Form!: FormGroup;
  page2Form!: FormGroup;
  page3Form!: FormGroup;
  isAdmin = false;
  subscriptions: Subscription[] = [];
  @Input() ViewRequestData: any;
  @Input() ViewRequestFlag: boolean = false;
  @Input() RequestIsPending: boolean = false;
  currentPage: number = 1;
  files = {} as any;
  saveError: any;
  phone_verified = false;
  mail_verified = false;
  facebook_verified = false;
  durationSelect = 3;
  cities: any;
  citiesSelect = "Cairo";
  isUpdate:number;
  data:object;
  frontImage:string;
  backImage:string
  imagesChanged: string [] = [];
  commercialImage:string;
  taxCardImage:string;
  CustomerSupportPhone: string = CONSTANT_CUSTOMER_SUPPORT_INFO.phone;

  constructor(
    private fetchBusinessData: CCFetchBusinessDataService,
    private saveBusinessData: CCSaveBusinessDataService,
    private router: Router,
    public sanitizer: DomSanitizer,
    private snackBar: MatSnackBar,
    private ng2ImgMax: Ng2ImgMaxService,
    private httpClient: HttpClient,
    private requestActionService: CCRequestActionService,
    private withdrawalStatusService: WithdrawalStatusService,
    private withdrawalUploadFileService: WithdrawalUploadFileService,
    private ActivationSubject: BehaviorSubjectActivationsService,
    private activeRoute : ActivatedRoute,
    private getActivationRequestService: GetActivationRequestService,
    private translate: TranslateService,
    private languageService: LanguageService,
    private auth: AuthService,
  ) { }

  download(url: any, saveName: any) {
    let extension = url.split('.')
    extension = extension[extension.length - 1]
    return this.httpClient.get(url,
      { responseType: 'blob' }).subscribe((data) => {
        var blob = new Blob([data]);
        saveAs(blob, `${saveName}.${extension}`);
      })
  }

  async ngOnInit() {
    this.translate.use(localStorage.getItem('language'));
    this.languageService.languageUpdated.subscribe((lang) => {
      this.translate.use(lang);
    })
    this.isAdmin = !!(await this.auth.getBusiness());

    this.cities = (cities as any).default;
    this.isUpdate = parseInt(this.activeRoute.snapshot.queryParamMap.get('isUpdate')) || 0;

    this.page1Form = this.fvPage1.createForm([
      {
        fieldName: 'businessName',
        defaultValue: null,
      },
      {
        fieldName: 'CPFullName',
        defaultValue: null,
      },
      {
        fieldName: 'email',
        defaultValue: null,
      },
      {
        fieldName: 'phoneNumber',
        defaultValue: null,
      },
      {
        fieldName: 'description',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      },
      {
        fieldName: 'website',
        defaultValue: null,
      },
      {
        fieldName: 'facebook',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]

      },
      {
        fieldName: 'facebook_verfication',
        defaultValue: null,
      },
      {
        fieldName: 'instagram',
        defaultValue: null,
      },
      {
        fieldName: 'hasRegisteredBusiness',
        defaultValue: false,
        validators: [
          {
            validatorFn: Validators.required,
            message: 'This question is required'
          }
        ]
      },
    ]);

    this.page2Form = this.fvPage2.createForm([
      {
        fieldName: 'commercialRegister',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      },
      {
        fieldName: 'taxCard',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      }
    ]);

    this.page3Form = this.fvPage3.createForm([
      {
        fieldName: 'productsDescription',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      },
      {
        fieldName: 'averagePrice',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      },
      {
        fieldName: 'customersFromEgypt',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      },
      {
        fieldName: 'personalIdFront',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      },
      {
        fieldName: 'personalIdBack',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          }
        ]
      }
    ]);
    let id: number = this.ViewRequestData ? this.ViewRequestData.BusinessId : null;
    this.getViewData(this.ViewRequestFlag, id)
  }

  ngAfterViewInit() {
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    })
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.fvPage1.validationMessages = {
        "description": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Description',
            fieldAr: 'الوصف'
          }),
        },
        "facebook": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Facebook',
            fieldAr: 'الفيسبوك'
          }),
        },
      }
      this.fvPage2.validationMessages = {
        "commercialRegister": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Commercial register',
            fieldAr: 'السجل التجاري'
          }),
        },
        "taxCard": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Tax card',
            fieldAr: 'بطاقة ضريبية'
          }),
        },
      }
      this.fvPage3.validationMessages = {
        "productsDescription": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Product description',
            fieldAr: 'وصف المنتج'
          }),
        },
        "averagePrice": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Average price',
            fieldAr: 'متوسط السعر'
          }),
        },
        "customersFromEgypt": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'This question',
            fieldAr: 'هذا السؤال'
          }),
        },
        "personalIdFront": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Personal id front',
            fieldAr: 'واجهة الهوية الشخصية'
          }),
        },
        "personalIdBack": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Personal id back',
            fieldAr: 'خلفية الهوية الشخصية'
          }),
        },
      }
    });
  }

  async getViewData(Flag:boolean, id :number){
    if (Flag) {
      this.fetchBusinessData.setParams({ businessId: id, isAdmin: true })
      this.page1Form.disable();
      this.page2Form.disable();
      this.page3Form.disable();
    }

    const result = await this.fetchBusinessData.make();
    this.page1Form.controls['businessName'].setValue(result.name);
    this.page1Form.controls['CPFullName'].setValue(result.Users[0].first_name + ' ' + result.Users[0].last_name);
    this.page1Form.controls['email'].setValue(result.Users[0].email);
    this.page1Form.controls['phoneNumber'].setValue(result.Users[0].phone);
    this.page1Form.controls['description'].setValue(result.description);
    this.page1Form.controls['facebook'].setValue(result.ActivationRequest ? result.ActivationRequest.facebookPage : null);
    let FBCode: number = result.ActivationRequest ?  result.ActivationRequest.facebookVerificationCode : null;
    this.page1Form.controls['facebook_verfication'].setValue(FBCode)
    this.mail_verified = result.Users[0].Verification.mail_verified
    this.phone_verified = result.Users[0].Verification.phone_verified
    this.facebook_verified = result.Users[0].Verification.facebook_verified
    let business = await this.auth.getBusiness();
    if(business?.id == result?.id){
      if((this.mail_verified && this.phone_verified)==false){
        this.router.navigate(['/']);
      }
    }
    if (this.isUpdate) {
      let business = JSON.parse(localStorage.getItem("business")) ;
      this.getActivationRequestService.setParams({
        businessId: business["id"] || null
      });
      const requestResult = await this.getActivationRequestService.make();
      this.data = requestResult["request"] || null;
      this.frontImage =
       (this.data["personalIdFront"]) ? this.data["personalIdFront"].split('ccRequestData%')[1] : "";
       this.backImage =
       (this.data["personalIdBack"]) ? this.data["personalIdBack"].split('ccRequestData%')[1] : "";
      this.commercialImage =
       (this.data["commercialRegister"]) ? this.data["commercialRegister"].split('ccRequestData%')[1] : "";
      this.taxCardImage =
       (this.data["taxCard"]) ? this.data["taxCard"].split('ccRequestDaccRequestData%')[1] : "";
    } else if (this.ViewRequestData) {
      this.data = this.ViewRequestData;
    }

    if (this.ViewRequestData || this.isUpdate) {
      this.page1Form.controls['hasRegisteredBusiness'].setValue(!!this.data["hasRegisteredBusiness"]);
      this.page1Form.controls['facebook'].setValue(result.ActivationRequest ? result.ActivationRequest.facebookPage : null);
      this.page1Form.controls['website'].setValue(this.data["website"]);
      this.page1Form.controls['instagram'].setValue(this.data["instagram"]);
      this.page2Form.controls['taxCard'].setValue(this.data["taxCard"]);
      this.page2Form.controls['commercialRegister'].setValue(this.data["commercialRegister"]);
      this.page3Form.controls['personalIdFront'].setValue(this.data["personalIdFront"]);
      this.page3Form.controls['personalIdBack'].setValue(this.data["personalIdBack"]);

      this.page3Form.controls['productsDescription'].setValue(this.data["productsDescription"]);
      this.page3Form.controls['customersFromEgypt'].setValue(this.data["customersFromEgypt"]);
      this.page3Form.controls['averagePrice'].setValue(this.data["averagePrice"]);

      this.page2Form.controls['commercialRegister'].setValue(this.data["commercialRegister"]);
      this.page2Form.controls['taxCard'].setValue(this.data["taxCard"]);

    }
  }

  async nextOrSubmit() {
    try {
      console.log("this.currentPage: ", this.currentPage);
      if (this.currentPage === 1 && this.ViewRequestFlag) {
        this.ViewRequestData.hasRegisteredBusiness
          ? (this.currentPage = 2)
          : (this.currentPage = 3);
        return;
      }
      if (this.currentPage === 1 &&
        this.isUpdate &&
        this.page1Form.value["hasRegisteredBusiness"]
      ) {
        this.currentPage = 2;
        return;
      }
      if (this.currentPage === 1 &&
        this.isUpdate &&
        !this.page1Form.value["hasRegisteredBusiness"]
      ) {
        this.currentPage = 3;
        return
      }

      if (this.currentPage === 1 && !this.ViewRequestFlag && !this.isUpdate ) {
        if (this.page1Form.valid) {
          if (this.page1Form.controls['hasRegisteredBusiness'].value === true) {
            this.currentPage = 2;
          } else {
            this.currentPage = 3;
          }
        } else {
          this.fvPage1.forceShowErrors();
        }
        return;
      } else if (this.currentPage === 2) {
        if (this.page2Form.invalid) {
          this.fvPage2.forceShowErrors();
          return;
        }
      } else if (this.currentPage === 3) {
        if (this.page3Form.invalid) {
          this.fvPage3.forceShowErrors();
          return;
        }
      }
      const formData = new FormData();
      let fileNames = [];
      const outputObject = { ...this.page1Form.value, ...this.page2Form.value, ...this.page3Form.value, ...this.files };
      outputObject.contractDeliveryDuration = this.durationSelect;
      outputObject.contractDeliveryGovernate = this.citiesSelect;
      for (const name of Object.keys(outputObject)) {

        if (['personalIdBack', 'personalIdFront', 'commercialRegister', 'taxCard'].indexOf(name) > -1 && outputObject[name]) {
          fileNames.push(name);
        }
        else {
          formData.append(name, outputObject[name]);
        }
      }
      this.saveBusinessData.setParams(formData);
      const result = await this.saveBusinessData.make();
      let showErrorImage = false;
      for (const fileName of fileNames) {
        if (! this.imagesChanged.includes(fileName) && this.isUpdate) {
          continue;
        }
        let fileFormData = new FormData();
        fileFormData.append('fileName', fileName);
        fileFormData.append('requestId', result.id);
        fileFormData.append(fileName, outputObject[fileName]);
        this.withdrawalUploadFileService.setParams(fileFormData);
        const res = await this.withdrawalUploadFileService.make();
        if (!res || !res.location) {
          showErrorImage = true;
          break;
        }
      }
      if (showErrorImage) {
        this.snackBar.open(this.translate.instant('Sellers.Products.CannotUploadImage'), '', {
          duration: 5000
        });
        return;
      }
      this.withdrawalStatusService.refetchBS.next(true);
      this.ActivationSubject.renderData.next(true);
      await this.showActivationRequestDisclaimer()

      this.snackBar.open(this.translate.instant('Sellers.Products.OrderPlaced'), '', {
        duration: 3000
      });
      this.router.navigate(["/seller/dashboard"])
    } catch (error) {
      console.log("error: ", error);
      this.saveError = error.message || error.faultyRequest.error.error;
    }
  }

  async accept() {
    if (
      !this.mail_verified ||
      !this.facebook_verified ||
      !this.phone_verified
    ) {
      this.snackBar.open(
        this.translate.instant('Sellers.Products.EmailNotVerified'),
        null,
        { duration: 3000 }
      );
      return;
    }
    this.requestActionService.setParams({ id: this.ViewRequestData.id, status: 'Approved' })
    await this.requestActionService.make();
    this.router.navigate(['/admin/requests/ActivationRequest']);
    this.snackBar.open(this.translate.instant('Sellers.Products.ActionSubmitted'), '', {
      duration: 3000
    });
  }

  async reject() {
    this.requestActionService.setParams({ id: this.ViewRequestData.id, status: 'Rejected' })
    await this.requestActionService.make();
    this.router.navigate(['/admin/requests/ActivationRequest']);
    this.snackBar.open(this.translate.instant('Sellers.Products.ActionSubmitted'), '', {
      duration: 3000
    });
  }

  getImagePreview(file: File) {
    const reader: FileReader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.imageSrc = reader.result;
    };
  }

  copyToClipboard(text: any) {
    let message = '';
    try {
      const selBox = document.createElement('textarea') as HTMLTextAreaElement;
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = text;
      document.body.appendChild(selBox);
      selBox.select();
      const success = document.execCommand('copy');
      document.body.removeChild(selBox);
      message = success ? this.translate.instant('Sellers.Products.CopiedToClipboard') : this.translate.instant('Sellers.Products.UnableToCopy');
    } catch (err) {
      message = this.translate.instant('Sellers.Products.UnableToCopy');
    } finally {
      this.snackBar.open(message, '', { duration: 2000 });
    }
  }

  fileChange(controlName, e, type) {
    this.files[controlName] = <File>e.target.files[0];
    if(type=='frontImg'){
      this.frontImage =  this.files[controlName].name;
      this.imagesChanged.push('personalIdFront')
    }else if(type=='backImg'){
      this.backImage =  this.files[controlName].name;
      this.imagesChanged.push('personalIdBack')
    }else if(type=='commercialImg'){
      this.commercialImage =  this.files[controlName].name;
      this.imagesChanged.push('commercialRegister')
    }else if(type=='taxCardImg'){
      this.taxCardImage =  this.files[controlName].name;
      this.imagesChanged.push('taxCard')
    }

    this.subscriptions.push(
      this.ng2ImgMax
        .compressImage(this.files[controlName], 0.2, true)
        .subscribe(
          (result) => {
            const image = new File([result], result.name);
            this.files[controlName] = image;
            this.getImagePreview(image);
          },
          (error) => {
            console.log('there is an', error);
          }
        )
    );
  }

  async nextOrPrevious(action:string){
    let id:number = this.ViewRequestData.id;
    if(action == 'next'){
      id = id+1;
      this.router.navigate([`/seller/settings/requestActivation/${id}`]);
    }else{
      id = id-1;
      this.router.navigate([`/seller/settings/requestActivation/${id}`]);
    }
  }

  uploadImage(type){
    if (type == "frontImg") {
      document.getElementById("frontImg").click();
    } else if (type == "backImg") {
      document.getElementById("backImg").click();
    } else if (type == "commercialImg") {
      document.getElementById("commercialImg").click();
    } else if (type == "taxCardImg") {
      document.getElementById("taxCardImg").click();
    }
  }

  async showActivationRequestDisclaimer() {
    return await Swal.fire({
      icon: 'info',
      showCloseButton: true,
      title: `${this.translate.instant('Sellers.Products.Disclaimer')}`,
      text: `${this.translate.instant('Sellers.Dashboard.ActivationDisclaimer')}`,
    });
  }

  ngOnChanges(){
    this.getViewData(true,this.ViewRequestData.BusinessId);
  }

  selectDurationChange(event: any) {
    this.durationSelect = Number(event.target.value);
  }

  selectGovernateChange(event: any) {

    this.citiesSelect = String(event.target.value);
  }

  convertPage1Controls(name: string) {
    return this.page1Form.get(name) as FormControl;
  }

  convertPage2Controls(name: string) {
    return this.page2Form.get(name) as FormControl;
  }

  convertPage3Controls(name: string) {
    return this.page3Form.get(name) as FormControl;
  }
}
